/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { NextActionSuggestionDefaultSettingBody } from '../models';
/**
 * NextActionSuggestionDefaultSettingApi - axios parameter creator
 * @export
 */
export const NextActionSuggestionDefaultSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 次のアクション候補デフォルト設定取得API
         * @summary 次のアクション候補デフォルト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestionDefaultSetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/next_action_suggestion_default_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 次のアクション候補デフォルト設定更新API（upsert）
         * @summary 次のアクション候補デフォルト設定更新API
         * @param {NextActionSuggestionDefaultSettingBody} nextActionSuggestionDefaultSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNextActionSuggestionDefaultSetting: async (nextActionSuggestionDefaultSettingBody: NextActionSuggestionDefaultSettingBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nextActionSuggestionDefaultSettingBody' is not null or undefined
            assertParamExists('putNextActionSuggestionDefaultSetting', 'nextActionSuggestionDefaultSettingBody', nextActionSuggestionDefaultSettingBody)
            const localVarPath = `/api/user/next_action_suggestion_default_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nextActionSuggestionDefaultSettingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NextActionSuggestionDefaultSettingApi - functional programming interface
 * @export
 */
export const NextActionSuggestionDefaultSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NextActionSuggestionDefaultSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * 次のアクション候補デフォルト設定取得API
         * @summary 次のアクション候補デフォルト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextActionSuggestionDefaultSetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextActionSuggestionDefaultSettingBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextActionSuggestionDefaultSetting(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 次のアクション候補デフォルト設定更新API（upsert）
         * @summary 次のアクション候補デフォルト設定更新API
         * @param {NextActionSuggestionDefaultSettingBody} nextActionSuggestionDefaultSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putNextActionSuggestionDefaultSetting(nextActionSuggestionDefaultSettingBody: NextActionSuggestionDefaultSettingBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putNextActionSuggestionDefaultSetting(nextActionSuggestionDefaultSettingBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NextActionSuggestionDefaultSettingApi - factory interface
 * @export
 */
export const NextActionSuggestionDefaultSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NextActionSuggestionDefaultSettingApiFp(configuration)
    return {
        /**
         * 次のアクション候補デフォルト設定取得API
         * @summary 次のアクション候補デフォルト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestionDefaultSetting(options?: any): AxiosPromise<NextActionSuggestionDefaultSettingBody> {
            return localVarFp.getNextActionSuggestionDefaultSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * 次のアクション候補デフォルト設定更新API（upsert）
         * @summary 次のアクション候補デフォルト設定更新API
         * @param {NextActionSuggestionDefaultSettingBody} nextActionSuggestionDefaultSettingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNextActionSuggestionDefaultSetting(nextActionSuggestionDefaultSettingBody: NextActionSuggestionDefaultSettingBody, options?: any): AxiosPromise<void> {
            return localVarFp.putNextActionSuggestionDefaultSetting(nextActionSuggestionDefaultSettingBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NextActionSuggestionDefaultSettingApi - interface
 * @export
 * @interface NextActionSuggestionDefaultSettingApi
 */
export interface NextActionSuggestionDefaultSettingApiInterface {
    /**
     * 次のアクション候補デフォルト設定取得API
     * @summary 次のアクション候補デフォルト設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionDefaultSettingApiInterface
     */
    getNextActionSuggestionDefaultSetting(options?: AxiosRequestConfig): AxiosPromise<NextActionSuggestionDefaultSettingBody>;

    /**
     * 次のアクション候補デフォルト設定更新API（upsert）
     * @summary 次のアクション候補デフォルト設定更新API
     * @param {NextActionSuggestionDefaultSettingBody} nextActionSuggestionDefaultSettingBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionDefaultSettingApiInterface
     */
    putNextActionSuggestionDefaultSetting(nextActionSuggestionDefaultSettingBody: NextActionSuggestionDefaultSettingBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putNextActionSuggestionDefaultSetting operation in NextActionSuggestionDefaultSettingApi.
 * @export
 * @interface NextActionSuggestionDefaultSettingApiPutNextActionSuggestionDefaultSettingRequest
 */
export interface NextActionSuggestionDefaultSettingApiPutNextActionSuggestionDefaultSettingRequest {
    /**
     * 
     * @type {NextActionSuggestionDefaultSettingBody}
     * @memberof NextActionSuggestionDefaultSettingApiPutNextActionSuggestionDefaultSetting
     */
    readonly nextActionSuggestionDefaultSettingBody: NextActionSuggestionDefaultSettingBody
}

/**
 * NextActionSuggestionDefaultSettingApi - object-oriented interface
 * @export
 * @class NextActionSuggestionDefaultSettingApi
 * @extends {BaseAPI}
 */
export class NextActionSuggestionDefaultSettingApi extends BaseAPI implements NextActionSuggestionDefaultSettingApiInterface {
    /**
     * 次のアクション候補デフォルト設定取得API
     * @summary 次のアクション候補デフォルト設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionDefaultSettingApi
     */
    public getNextActionSuggestionDefaultSetting(options?: AxiosRequestConfig) {
        return NextActionSuggestionDefaultSettingApiFp(this.configuration).getNextActionSuggestionDefaultSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 次のアクション候補デフォルト設定更新API（upsert）
     * @summary 次のアクション候補デフォルト設定更新API
     * @param {NextActionSuggestionDefaultSettingApiPutNextActionSuggestionDefaultSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NextActionSuggestionDefaultSettingApi
     */
    public putNextActionSuggestionDefaultSetting(requestParameters: NextActionSuggestionDefaultSettingApiPutNextActionSuggestionDefaultSettingRequest, options?: AxiosRequestConfig) {
        return NextActionSuggestionDefaultSettingApiFp(this.configuration).putNextActionSuggestionDefaultSetting(requestParameters.nextActionSuggestionDefaultSettingBody, options).then((request) => request(this.axios, this.basePath));
    }
}
